/**
 * Environment access — single point of truth.
 * Auth split matches HOTTR.tv:
 *   - Optional app data: VITE_SUPABASE_*
 *   - Passport identity: VITE_PASSPORT_* + passport.hottr.world SSO
 *   - Soft-launch PIN: VITE_PIN_ACCESS_CODE / PIN_ACCESS_CODE (client gate only)
 */

const read = (key: string): string => {
  const envBag = (
    import.meta as ImportMeta & { env: Record<string, string | boolean | undefined> }
  ).env;
  const value = envBag?.[key];
  return typeof value === 'string' ? value.trim() : '';
};

const pinFromDefine =
  typeof __PIN_ACCESS_CODE__ !== 'undefined'
    ? String(__PIN_ACCESS_CODE__ || '').trim()
    : '';

const supabaseUrl = read('VITE_SUPABASE_URL');
const supabaseAnonKey = read('VITE_SUPABASE_ANON_KEY');
const pinAccessCode =
  pinFromDefine || read('VITE_PIN_ACCESS_CODE') || read('PIN_ACCESS_CODE');

const passportSupabaseUrl =
  read('VITE_PASSPORT_SUPABASE_URL') || 'https://xsbqsfrfkdhhcscnalqk.supabase.co';
const passportSupabaseAnonKey = read('VITE_PASSPORT_SUPABASE_ANON_KEY');
const passportUrl = read('VITE_PASSPORT_URL') || 'https://passport.hottr.world';

export const env = {
  supabaseUrl,
  supabaseAnonKey,
  surface: read('VITE_HOTTR_SURFACE') || 'hottr.me',
  passportSupabaseUrl,
  passportSupabaseAnonKey,
  passportUrl,
  pinAccessCode,
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
} as const;

export const hasSupabase = (): boolean =>
  Boolean(env.supabaseUrl && env.supabaseAnonKey);

export const hasPassportAuth = (): boolean =>
  Boolean(env.passportSupabaseUrl && env.passportSupabaseAnonKey);

export const hasPassport = (): boolean => Boolean(env.passportUrl);

export const hasPinGate = (): boolean => env.pinAccessCode.length > 0;

declare const __PIN_ACCESS_CODE__: string | undefined;
